var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bigbg',{attrs:{"url":_vm.bandat.bgImg,"bigtext":_vm.bandat.title,"smalltext":_vm.bandat.subtitle}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.pagetable)}}),_c('Header'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }